document.addEventListener('DOMContentLoaded', function() {
    // Simple script for mobile menu toggle
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenuButton && mobileMenu) {
        mobileMenuButton.addEventListener('click', () => {
            mobileMenu.classList.toggle('hidden');
        });
    }

    // Makes the header background more solid on scroll
    const header = document.getElementById('header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('bg-gray-900');
                header.classList.remove('bg-gray-900/80');
            } else {
                header.classList.remove('bg-gray-900');
                header.classList.add('bg-gray-900/80');
            }
        });
    }
});
